import * as actionTypes from "./actionTypes";

export const feedBackAction = params => ({
	type: actionTypes.FEED_BACK_ACTION,
	params
});
